import React from 'react';
import { Steps } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const { Step } = Steps;

const InviteSteps = ({ currentStep }) => {
  const { t } = useTranslation();

  return (
    <>
      <Steps direction="vertical" size="small" current={currentStep}>
        <Step
          title={t('REGISTER_STEP.CREATE_USER_ACCOUNT_HEADER')}
          description={t('REGISTER_STEP.USER_ACCOUNT_DESC')}
          key="0"
        />
        <Step
          title={t('REGISTER_STEP.COMPANY_DETAILS_HEADER')}
          description={t('REGISTER_STEP.COMPANY_DETAILS_DESC')}
          key="1"
        />
      </Steps>
    </>
  );
};

InviteSteps.propTypes = {
  currentStep: PropTypes.number,
};

InviteSteps.defaultProps = {
  currentStep: 0,
};

export default InviteSteps;
